import { FC, useEffect, useState } from 'react';
import V2Operate from '@/common/components/Others/V2Operate';
import { isArray } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { getTemplateLists } from '@/common/api/expandStore/chancepoint';
import SelectTemplateModal from '@/common/components/business/ExpandStore/ChanceCreateDrawer/SelectTemplateModal';
import ChanceCreateDrawer from '@/common/components/business/ExpandStore/ChanceCreateDrawer';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { postChancePointCreateFromSurveyRecord } from '@/common/api/expandStore/spotSurvey';
// import copy from 'copy-to-clipboard';
// import { useCreateShareContentLink } from '@/common/hook/useShareContent';

/**
 * @Description 踩点详情抽屉-顶部右上角操作按钮
 */
const TitleOperate: FC<{
  detail: any; // 踩点详情
  operateList: any[]; // 处理好的处理按钮
  createChanceLoading: boolean;
  setCreateChanceLoading: any; // 机会点创建用数据生成中
  standardChancePointAlias: any;
  setRefreshChanceFlag: any;
}> = ({
  detail,
  operateList,
  createChanceLoading,
  setCreateChanceLoading,
  standardChancePointAlias,
  setRefreshChanceFlag,
}) => {
  const [templateList, setTemplateList] = useState<any[]>([]);
  const [selectTemplateVisible, setSelectTemplateVisible] = useState<boolean>(false);
  const [formDrawerData, setFormDrawerData] = useState<any>({
    open: false,
    templateId: '', // 模板id
    id: '', // 编辑时的id
  }); // 机会点详情上的编辑

  // const { createShareContentLink } = useCreateShareContentLink();
  useEffect(() => {
    methods.getChanceTemplates();
  }, []);

  const methods = useMethods({
    /**
     * @description 点击按钮-分享
     */
    // async handleShare() {
    //   console.log('handleShare');
    //   const url = await createShareContentLink({ shareUrl: '/expandstore/spotsurveydetail', params: { id: detail?.id } });
    //   console.log('url', url);
    //   copy(url);
    // },

    /**
     * @description 点击按钮-新建机会点
     */
    async handleCreateChancePoint() {
      if (createChanceLoading) return;

      if (!templateList.length) {
        await methods.getChanceTemplates();
      }
      /*
        单一机会点模板：直接打开创建机会点抽屉
        多个机会点模板：展示选择模板弹框
      */
      templateList?.length === 1 ? methods.onSelectTemplate({ templateId: templateList[0]?.value }) : setSelectTemplateVisible(true);
    },

    /**
     * @description 获取模板列表
     */
    async getChanceTemplates() {
      const res = await getTemplateLists();
      if (isArray(res)) {
        setTemplateList(res.map((item) => ({ label: item.templateName, value: item.id })));
      }
    },

    /**
     * @description 从模板列表选中后回调，请求接口后静默创建机会点，成功后编辑模式打开抽屉
     */
    async onSelectTemplate(data: any) {
      const { templateId } = data || {};
      if (createChanceLoading || !templateId) return;

      setCreateChanceLoading(true);
      const res = await postChancePointCreateFromSurveyRecord({
        spotSurveyId: detail?.id,
        dynamicRelationId: templateId,
      }).finally(() => {
        setCreateChanceLoading(false);
      });

      setFormDrawerData({
        templateId: templateList[0]?.value,
        open: true,
        id: res?.id,
      });
    }
  });

  return (
    <div>
      <V2Operate operateList={operateList} onClick={(btn) => methods[btn.func]()} />

      {/* 模版选择框  */}
      <SelectTemplateModal
        setVisible={setSelectTemplateVisible}
        visible={selectTemplateVisible}
        chancepointAlias={standardChancePointAlias}
        onSelectTemplate={methods.onSelectTemplate}
      />
      {/* 机会点详情 */}
      <ChanceCreateDrawer
        drawerData={formDrawerData}
        chancepointAlias={standardChancePointAlias}
        handleEditSuccessed={() => {
          // 实质上是后端静默create,前端用户完善信息后update，但是从用户交互来说整个流程是创建操作
          V2Message.success(`${standardChancePointAlias}创建成功`);
          setRefreshChanceFlag((state) => ++state);
        }}
        onSearch={() => {}}
        closeHandle={() =>
          setFormDrawerData({
            open: false,
            templateId: '', // 模板id
            id: '', // 编辑时的id
          })
        }
      />
    </div>
  );
};

export default TitleOperate;
